import { lazy } from 'react';
import RolesGuard from 'src/components/RolesGuard';

export const Routes = [
    {
        exact: true,
        path: '/conversations',
        guard: RolesGuard,
        roles: [
            'rockstar',
            'admin',
            'super admin',
            'user',
            'adminBDC',
            'userBDC',
            'sales manager',
            'general manager',
            'marketing',
            'marketing digital',
        ],
        component: lazy(() => import('src/views/dpxChat')),
    },
];
